import { render, staticRenderFns } from "./DocumentsTableTab.vue?vue&type=template&id=a3fdd6ac&"
import script from "./DocumentsTableTab.vue?vue&type=script&lang=js&"
export * from "./DocumentsTableTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports